import { BASE_URL } from '../../Resources/Api';
import axios from "axios";
import moment from 'moment';

// const authToken = localStorage.getItem('accessToken');

// Get User List
export function getEmployee(toast, authToken) {
   return async function (dispatch) {
      dispatch({
         type: 'LOADING_STATUS',
         payload: {
            status: true,
            string: 'list'
         }
      })

      axios({
         method: 'GET',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: BASE_URL + 'employee',
      })
         .then(function (response) {
            // console.log('Department Action=================', response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  dispatch({
                     type: 'GET_EMPLOYEE',
                     payload: response.data.data
                  })
                  dispatch({
                     type: 'LOADING_STATUS',
                     payload: {
                        status: false,
                        string: 'list'
                     }
                  })
               } else {
                  dispatch({
                     type: 'LOADING_STATUS',
                     payload: {
                        status: false,
                        string: 'list'
                     }
                  })
                  toast.warn('No reord found');
               }
            } else {
               dispatch({
                  type: 'LOADING_STATUS',
                  payload: {
                     status: false,
                     string: 'list'
                  }
               })
               toast.warn(response.data.message);
            }
         })
         .catch(function (error) {
            dispatch({
               type: 'LOADING_STATUS',
               payload: false
            })
            toast.error('Something went wront. Please try again');
            console.log(error);
         });
   }
}

// Save Action
export function saveEmployee(values, actions, setOpenModal, actionMode, toast, authToken) {
   return async function (dispatch) {
      // console.log(values)
      actions.setSubmitting(true)
      const formData = new FormData();
      formData.append('id', values.id);
      formData.append('name', values.name);
      formData.append('father_name', values.father_name);
      formData.append('emp_id', values.emp_id);
      formData.append('card_no', values.card_no);
      formData.append('voter_id', values.voter_id);
      formData.append('aadhaar_id', values.aadhaar_id);
      formData.append('gender', values.gender);
      formData.append('dob', moment(values.dob).format('YYYY-MM-DD'));
      formData.append('doj', moment(values.doj).format('YYYY-MM-DD'));
      formData.append('address', values.address);
      formData.append('area', values.area);
      formData.append('image', values.image);
      formData.append('daily_rate', values.daily_rate);
      axios({
         method: 'POST',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: BASE_URL + 'employee',
         data: formData
      })
         .then(function (response) {
            // console.log('Banner Category Action=================', response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  toast.success(response.data.message)
                  actions.setSubmitting(false)
                  actions.resetForm()
                  if (actionMode === "Edit") {
                     dispatch(getEmployee(toast, authToken));
                     setOpenModal(false);
                  }
               } else {
                  actions.setErrors(response.data.message)
                  actions.setSubmitting(false)
               }
            }
         })
         .catch(function (error) {
            actions.setSubmitting(false)
            toast.error('Something went wrong. Please try again.')
            console.log(error);
         });
   }
}

// Save Action
export function updateEmployee(values, id, actions, setOpenModal, actionMode, toast, authToken) {
   return async function (dispatch) {
      console.log(values)
      actions.setSubmitting(true)

      axios({
         method: 'POST',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: `${BASE_URL}employee/${id}`,
         data: {
            name: values.name,
            father_name: values.father_name,
            emp_id: values.emp_id,
            card_no: values.card_no,
            voter_id: values.voter_id,
            aadhaar_id: values.aadhaar_id,
            gender: values.gender,
            dob: moment(values.dob).format('YYYY-MM-DD'),
            doj: moment(values.doj).format('YYYY-MM-DD'),
            address: values.address,
            area: values.area,
            image: values.image
         }
      })
         .then(function (response) {
            // console.log('Banner Category Action=================', response.data);
            if (response.status === 200) {
               if (response.data.status === true) {
                  toast.success(response.data.message)
                  actions.setSubmitting(false)
                  actions.resetForm()
                  if (actionMode === "Edit") {
                     dispatch(getEmployee(toast, authToken));
                     setOpenModal(false);
                  }
               } else {
                  actions.setErrors(response.data.message)
                  actions.setSubmitting(false)
               }
            }
         })
         .catch(function (error) {
            actions.setSubmitting(false)
            toast.error('Something went wrong. Please try again.')
            console.log(error);
         });
   }
}


// Delete User
export function deleteEmployee(values, actions, setOpenConfirm, toast, authToken) {
   return async function (dispatch) {
      // console.log(id)
      actions.setSubmitting(true)
      dispatch({
         type: 'MESSAGE',
         payload: false
      })

      axios({
         method: 'DELETE',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: `${BASE_URL}employee/${values.id}`,
      })
         .then(function (response) {
            // console.log('Auth Action=================', response);
            if (response.status === 200) {
               if (response.data.status === true) {
                  actions.setSubmitting(false)
                  toast.success(response.data.message);
                  setOpenConfirm(false)
                  dispatch(getEmployee(toast, authToken));
               } else {
                  actions.setSubmitting(false)
                  toast.warn(response.data.message);
               }
            } else {
               actions.setSubmitting(false)
               toast.success(response.data.message);
            }
         })
         .catch(function (error) {
            actions.setSubmitting(false)
            toast.success("Something went wrong. Please tryagain.");
            console.log(error);
         });
   }
}


// Delete User
export function statusEmployee(values, actions, setOpenConfirm, toast, authToken) {
   return async function (dispatch) {
      // console.log(id)
      actions.setSubmitting(true)

      axios({
         method: 'PATCH',
         headers: {
            Authorization: 'Bearer ' + authToken,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
         },
         url: `${BASE_URL}employee/${values.id}`,
         data: {
            status: values.status
         }
      })
         .then(function (response) {
            // console.log('Auth Action=================', response);
            if (response.status === 200) {
               if (response.data.status === true) {
                  actions.setSubmitting(false)
                  toast.success(response.data.message);
                  setOpenConfirm(false)
                  dispatch(getEmployee(toast, authToken));
               } else {
                  actions.setSubmitting(false)
                  toast.warn(response.data.message);
               }
            } else {
               actions.setSubmitting(false)
               toast.warn(response.data.message);
            }
         })
         .catch(function (error) {
            actions.setSubmitting(false)
            toast.success("Something went wrong. Please tryagain.");
            console.log(error);
         });
   }
}

